import { createBrowserRouter } from 'react-router-dom';
import { LandingPage } from '@/features/auth/pages/LandingPage';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { SignupPage } from '@/features/auth/pages/SignupPage';
import { ForgotPasswordPage } from '@/features/auth/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/features/auth/pages/ResetPasswordPage';
import { TermsPage } from '@/features/legal/pages/TermsPage';
import { PrivacyPage } from '@/features/legal/pages/PrivacyPage';
import { BillingPage } from '@/features/billing/pages/BillingPage';
import { BillingReturnPage } from '@/features/billing/pages/BillingReturnPage';
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage';
import { EditorPage } from '@/features/editor/pages/EditorPage';
import { SettingsPage } from '@/features/settings/pages/SettingsPage';
import { AdminPage } from '@/features/admin/pages/AdminPage';
import { ProjectsPage } from '@/features/projects/pages/ProjectsPage';
import { PublicSharePage } from '@/features/share/pages/PublicSharePage';
import { SupportPage } from '@/features/support/pages/SupportPage';
import { AuthGuard } from '@/features/auth/components/AuthGuard';
import { GuestGuard } from '@/features/auth/components/GuestGuard';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <GuestGuard>
        <LandingPage />
      </GuestGuard>
    ),
  },
  {
    path: '/login',
    element: (
      <GuestGuard>
        <LoginPage />
      </GuestGuard>
    ),
  },
  {
    path: '/signup',
    element: (
      <GuestGuard>
        <SignupPage />
      </GuestGuard>
    ),
  },
  {
    path: '/forgot-password',
    element: (
      <GuestGuard>
        <ForgotPasswordPage />
      </GuestGuard>
    ),
  },
  {
    path: '/reset-password',
    // No guard — an authenticated user who follows a reset link from email
    // should still land here (they might be fixing a different account).
    element: <ResetPasswordPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/billing',
    element: (
      <AuthGuard>
        <BillingPage />
      </AuthGuard>
    ),
  },
  {
    path: '/billing/return',
    element: (
      <AuthGuard>
        <BillingReturnPage />
      </AuthGuard>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <AuthGuard>
        <DashboardPage />
      </AuthGuard>
    ),
  },
  {
    path: '/editor/:projectId?',
    element: (
      <AuthGuard>
        <EditorPage />
      </AuthGuard>
    ),
  },
  {
    path: '/settings',
    element: (
      <AuthGuard>
        <SettingsPage />
      </AuthGuard>
    ),
  },
  {
    path: '/projects',
    element: (
      <AuthGuard>
        <ProjectsPage />
      </AuthGuard>
    ),
  },
  {
    path: '/admin',
    element: (
      <AuthGuard>
        <AdminPage />
      </AuthGuard>
    ),
  },
  {
    // Public share viewer — no auth.
    path: '/share/:token',
    element: <PublicSharePage />,
  },
  {
    // Public support / feedback form. Pre-fills user info when signed in.
    path: '/support',
    element: <SupportPage />,
  },
]);
